import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type EditKeyLockerPayload = {
  name: string;
  keylocker_id: number;
  is_2fa_to_drop_key_enabled: boolean;
};

export const useUpdateKeyLockerMutation = () =>
  useTypedMutation<EditKeyLockerPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/dashboard/update", payload, ENV.keylockerBaseURL);
    },
    onSuccess: payload => {
      const keyLockers = typedQueryClient.getQueryData(KeyLockersQueryKeys.keyLockers);
      if (!keyLockers) return;

      const keyLockerIdx = keyLockers.findIndex(keyLocker => keyLocker.id === payload.keylocker_id);
      if (keyLockerIdx === -1) return;

      typedQueryClient.setQueryData(KeyLockersQueryKeys.keyLockers, keyLockers.with(keyLockerIdx, { ...keyLockers[keyLockerIdx], ...payload }));
    }
  });
